import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getFinancingTermsOverview } from '../../ducks/selectors';
import { SoftPullMfeConfig } from '../../../../utilities/softPullMfeConfig';
import SoftPullMfeModal, {
  attachSoftPullModalSubmittedEvent,
  openSoftPullModal,
  removeSoftPullModalSubmittedEvent
} from '../../../../shared/components/SoftPullMfeModal';
import { CoSignerButton } from './ManageCoSignerButton.styles';

const ManageCoSignerButton = () => {
  const { cosignerAllowed, hasCoApplicant } = useSelector(getFinancingTermsOverview) ?? {};

  const reloadOnSuccess = () => {
    document.location.reload();
  };

  const handleSoftPullClick = () => {
    attachSoftPullModalSubmittedEvent(reloadOnSuccess);
    if (cosignerAllowed && hasCoApplicant) {
      openSoftPullModal({ isEditCoSigner: true });
    } else {
      openSoftPullModal({ isAddCoSigner: true });
    }
  };

  useEffect(() => {
    SoftPullMfeConfig();

    return () => {
      removeSoftPullModalSubmittedEvent(reloadOnSuccess);
    };
  }, []);

  return (
    <>
      <SoftPullMfeModal />
      <CoSignerButton type="button" onClick={handleSoftPullClick}>
        {cosignerAllowed && hasCoApplicant ? 'Edit co-signer info' : 'Add co-signer'}
      </CoSignerButton>
    </>
  );
};

export default ManageCoSignerButton;
